export default __webpack_public_path__ + "static/media/Linkedin-Insightful.c25d8f76.png";